'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  ConversationActionProps,
  ConversationActionType,
} from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { clickEvent, viewEvent } from '@marketplace-web/vas/vas-data'

import { CLOSET_PROMOTION_STATS_URL } from '../../../constants/routes'

const PromotedClosetStats = ({ primary, title, inverse, theme, size }: ConversationActionProps) => {
  const { track } = useTracking()

  useEffect(() => {
    track(
      viewEvent({
        screen: 'message_reply',
        target: 'cp_reminder',
        targetDetails: JSON.stringify({
          action: ConversationActionType.PromotedClosetStats,
        }),
      }),
    )
  }, [track])

  const handleClick = () => {
    track(
      clickEvent({
        screen: 'message_reply',
        target: 'cp_reminder',
        targetDetails: JSON.stringify({
          action: ConversationActionType.PromotedClosetStats,
        }),
      }),
    )
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={CLOSET_PROMOTION_STATS_URL}
      onClick={handleClick}
    />
  )
}

export default PromotedClosetStats
